import React from "react";

export default function Loading() {
  return (
    <section className="h-screen flex justify-center flex-col items-center relative z-50 bg-white">
      <h1 className="text-3xl text-gray-900 mt-12">Doing something...</h1>
    </section>
  );
}
